import { compoundKey } from './merge-by-timestamp.js';
/**
 * For each provider, compute the writes needed to bring it in line with the winners.
 * - Missing key on provider: write the winning record.
 * - Stale key on provider: overwrite with the winning record.
 * - Tombstoned winner but provider still holds a live record: write tombstone.
 */
export function planReadRepair(winners, perProvider) {
    const actions = [];
    const refsIndex = new Map();
    for (const { providerId, refs } of perProvider) {
        const m = new Map();
        for (const r of refs)
            m.set(compoundKey(r.namespace, r.key), r);
        refsIndex.set(providerId, m);
    }
    for (const winner of winners.values()) {
        const ck = compoundKey(winner.namespace, winner.key);
        for (const { providerId } of perProvider) {
            if (providerId === winner.providerId)
                continue;
            const have = refsIndex.get(providerId)?.get(ck);
            if (winner.deletedAt) {
                if (!have || (have.deletedAt ?? '') < winner.deletedAt) {
                    actions.push({
                        providerId,
                        namespace: winner.namespace,
                        key: winner.key,
                        sourceProviderId: winner.providerId,
                        isTombstone: true,
                        deletedAt: winner.deletedAt,
                    });
                }
                continue;
            }
            if (!have || have.updatedAt < winner.updatedAt) {
                actions.push({
                    providerId,
                    namespace: winner.namespace,
                    key: winner.key,
                    sourceProviderId: winner.providerId,
                    isTombstone: false,
                });
            }
        }
    }
    return actions;
}
//# sourceMappingURL=read-repair.js.map